// @flow
import type { ComponentType } from 'react';
import React from 'react';

import styles from './routeStopCardContent.css';


type RouteEmptyListPropTypes = {
  title: string,
  Icon?: ComponentType<any>
};

const RouteEmptyList = ({
  title = '',
  Icon,
}: RouteEmptyListPropTypes) => (
  <div className={styles.routeEmptyContainer}>
    {
      typeof Icon !== 'undefined'
        && (
          <div className={styles.iconContainer}>
            <Icon size={80} />
          </div>
        )
    }
    <div className={styles.emptyTitle}>
      { title }
    </div>
  </div>
);

export default RouteEmptyList;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStopsCardContent/routeEmptyList.js